export const AzureADIntegrationLink = '/admin-guide/setting-up-the-azure-ad-integration';
